import { v4 as uuid } from 'uuid';
import { DocumentMetadataPropertyTypeEnum, SearchAggregationType, } from 'shared/domains/apollo/generated/types';
import { TERMS_AGGREGATION_MISSING_VALUE_NAME } from '../../../constants';
import { getMetadataProperty } from '../../../utils/metadataProperties';
const STATIC_FIELDS_WITH_MISSING_BUCKET = [
    'categoryId',
    'marketCode',
    'marketLocaleCode',
    'metadataDocumentEsigningStatus',
    'metadataDocumentType',
];
function getMissingConfigurationValue(field) {
    const property = getMetadataProperty(field);
    const isListLike = (property === null || property === void 0 ? void 0 : property.type) === DocumentMetadataPropertyTypeEnum.List ||
        (property === null || property === void 0 ? void 0 : property.type) === DocumentMetadataPropertyTypeEnum.Reference;
    if (isListLike || STATIC_FIELDS_WITH_MISSING_BUCKET.includes(field)) {
        return TERMS_AGGREGATION_MISSING_VALUE_NAME;
    }
    return null;
}
export const getDefaultTermsValue = (field) => ({
    type: SearchAggregationType.Terms,
    name: uuid(),
    termsInput: {
        field,
        size: 10,
        missing: getMissingConfigurationValue(field),
    },
});
